import { createEvent, createStore } from 'effector';

export interface ConfirmRequest {
  title: string;
  body: string;
  confirmLabel: string;
  danger?: boolean;
  onConfirm: () => Promise<unknown>;
}

export const confirmRequested = createEvent<ConfirmRequest>();
export const closed = createEvent();
export const $request = createStore<ConfirmRequest | null>(null)
  .on(confirmRequested, (_, request) => request)
  .reset(closed);
